import type { PlayerActorAssetStatus, PlayerAssetStatusState } from '../types';
import { usePlayerStore } from '../store/playerStore';

export const INITIAL_PLAYER_ASSET_STATUS: PlayerAssetStatusState = {
  meshStatus: 'initial',
  animationStatus: 'initial',
  error: null,
};

export function derivePlayerActorAssetStatus(
  actorId: string,
  assetStatus: PlayerAssetStatusState = INITIAL_PLAYER_ASSET_STATUS,
): PlayerActorAssetStatus {
  return {
    actorId,
    meshStatus: assetStatus.meshStatus,
    animationStatus: assetStatus.animationStatus,
    isLoading:
      assetStatus.meshStatus === 'pending' ||
      assetStatus.animationStatus === 'pending',
    isReady:
      assetStatus.meshStatus === 'ready' &&
      assetStatus.animationStatus === 'ready',
    error: assetStatus.error,
  };
}

export function usePlayerActorAssetStatus(actorId?: string) {
  const store = usePlayerStore();
  const { activeActorId, assetStatusByActorId } = store.state;
  const resolvedActorId = actorId ?? activeActorId;

  if (!resolvedActorId) {
    return null;
  }

  return derivePlayerActorAssetStatus(
    resolvedActorId,
    assetStatusByActorId[resolvedActorId],
  );
}
